export const SET_SHIPPING_LOADING = 'shipping/SET_SHIPPING_LOADING';
export const SET_DIRECT_SHIPPING_STATUS = 'shipping/SET_DIRECT_SHIPPING_STATUS';
export const SET_RETURN_SHIPPING_STATUS = 'shipping/SET_RETURN_SHIPPING_STATUS';
export const SET_TRANSACTIONS = 'shipping/SET_TRANSACTIONS';
